import { AnchorButtonProps, AnchorButton } from './Styles'

const Anchor = (props: AnchorButtonProps) => (
  <AnchorButton
    {...props}
    onClick={e => {
      if (props.disabled) {
        return
      }

      if (props.onClick) {
        props.onClick(e)
      }
    }}
  />
)

export default Anchor
